<template>
  <Modal v-model="changeTheOriginOfTheProductModal" :title="placeOfOriginTitle" width="500" class-name="changeCurrencyStyle"
    :transfer="false" :mask-closable="false" @on-visible-change="changeCurrencyChange">
    <Form ref="placeOfOriginForm" :model="placeOfOriginForm" :label-width="100" @submit.native.prevent>
      <Row type="flex" :gutter="gutterItem" style="width: 90%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1000935')" prop="placeOfOrigin">
            <Select v-model="placeOfOriginForm.originalCountryCode" filterable transfer>
              <Option v-for="item in countrysList" :value="item.twoCode" :key="item.twoCode">{{ item.name }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="changeTheOriginOfTheProductModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="!placeOfOriginForm.originalCountryCode" @click="savePlaceOfOriginBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllCountrysData, getSupplierConfigurationItemData, saveErpCommonSettingParam} from "@/utils/common";

export default {
  name: 'changeTheOriginOfTheProductModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      changeTheOriginOfTheProductModal: false,
      placeOfOriginForm: {
        originalCountryCode: null
      },
      countrysList: [],
      configParamKey: 'productDefaultOriginalCountryCode',
      placeOfOriginTitle: '',
    }
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
  },
  methods: {
    // 初始化数据
    async initPlaceOfOriginData(value) {
      this.countrysList = await getAllCountrysData('cn', true);
      this.placeOfOriginForm.originalCountryCode = value;
      this.placeOfOriginTitle = value ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006780') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006781');
      this.changeTheOriginOfTheProductModal = true;
    },
    // 修改原产地保存按钮
    savePlaceOfOriginBtn() {
      let queryList = [
        {
          businessId: this.userInfo.merchantId,
          paramKey: this.configParamKey,
          paramValue: this.placeOfOriginForm.originalCountryCode,
        }
      ];
      saveErpCommonSettingParam(queryList).then(() => {
        this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000705'));
        this.changeTheOriginOfTheProductModal = false;
        this.$emit('updatePlaceOfOrigin', this.placeOfOriginForm.originalCountryCode);
        getSupplierConfigurationItemData(true);
      });
    },
    // 监听弹窗
    changeCurrencyChange(value) {
      if (!value) {
        this.placeOfOriginForm.originalCountryCode = null;
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
